// a library to wrap and simplify api calls
import axios from 'axios'

export const serverUrl = 'https://guardx.devx.agency/api/'

// config
import { config } from '../../Config/ConfigLoader'

// our "constructor"
export const guardXApi = axios.create({
  baseURL: `${serverUrl}`,
  timeout: 100000,
  headers: {
    'Content-Type': 'application/json',
    Authorization: '648sr5lp86u9mp6v'
  },
  transformRequest: [(data, headers) => {
    delete headers.common['X-Tracking-googleClientId']
    return JSON.stringify(data)
  }]
})

const setHeader = (name, value) => {
  if (value) {
    axios.defaults.headers.common[name] = value
  } else {
    delete axios.defaults.headers.common[name]
  }
}

const endpoints = (api) => ({
  // post
  writeEntry: (data) => api.post(`${config.getConfig('guardXApiKey')}/log`, data),
  // get
  // delete
  // helpers
  serverUrl,
  setHeader,
})

export const rawEndpoints = endpoints

export default endpoints(guardXApi)
